// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Grid,
//   Select,
//   MenuItem,
//   IconButton,
//   InputLabel,
//   Pagination,
//   Button,
//   Dialog,
//   DialogTitle,
// } from '@mui/material';
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import * as XLSX from 'xlsx';
// import { useMain } from '../hooks/useMain';
// import PageContainer from 'src/components/container/PageContainer';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import SearchImg from '../../assets/search.svg';
// import ClearIcon from '@mui/icons-material/Clear';
// import SingleProduct from './SingleProduct';
// import FilterProduct from './FilterProduct';
// import ProductGraph from './productGraph/ProductGraph';
// import Book1ConsumeableProduct from '../../assets/excel/Book1ConsumeableProduct.xlsx'; // your sample file

// const ManageConsumeProducts = () => {
//   const [allConsumeproducts, setAllConsumeProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [showLoader, setShowLoader] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedProductIds, setSelectedProductIds] = useState([]);
//   const [uploadedData, setUploadedData] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Filter states
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [selectedMonth, setSelectedMonth] = useState('');
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

//   const [pagination, setPagination] = useState({
//     itemsPerPage: 10,
//     currentPage: 1,
//     totalPages: 1,
//   });

//   const { fetchAllConsumeProducts,createManyConsumeableProduct, activeBranchId, setShowMessage } = useMain();

//   // ✅ CreateManyConsumeableProduct API function (local)
//   // const createManyConsumeableProduct = async (branchId, data) => {
//   //   try {
//   //     const response = await fetch(
//   //       `${process.env.REACT_APP_BASE_URL}/api/consumeableproduct/bulkUpload/${branchId}`,
//   //       {
//   //         method: 'POST',
//   //         headers: {
//   //           'Content-Type': 'application/json',
//   //           Authorization: localStorage.getItem('token') || '',
//   //         },
//   //         body: JSON.stringify(data),
//   //       }
//   //     );
//   //     return await response.json();
//   //   } catch (err) {
//   //     return { statusCode: 500, message: err.message };
//   //   }
//   // };

//   useEffect(() => {
//     if (activeBranchId) {
//       getData();
//     }
//   }, [activeBranchId, selectedProductIds, startDate, endDate, selectedMonth, selectedYear]);

//   useEffect(() => {
//     filterProducts();
//   }, [allConsumeproducts, searchTerm, pagination.itemsPerPage, pagination.currentPage]);

//   const getData = async () => {
//     try {
//       setShowLoader(true);
//       let queryParams = ``;

//       if (startDate && endDate) {
//         queryParams += `&startDate=${startDate}&endDate=${endDate}`;
//       }

//       if (selectedMonth) {
//         queryParams += `&month=${selectedMonth}&year=${selectedYear}`;
//       }

//       const res = await fetchAllConsumeProducts(activeBranchId, queryParams ? `?${queryParams.slice(1)}` : '');

//       if (res.statusCode === 200) {
//         setAllConsumeProducts(res.data);
//         calculatePagination(res.data);
//       } else {
//         setShowMessage({
//           message: res.message || 'Failed to fetch data',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   const filterProducts = () => {
//     let filtered = [...allConsumeproducts];
//     if (selectedProductIds.length > 0) {
//       filtered = filtered.filter((product) => selectedProductIds.includes(product._id));
//     }
//     if (searchTerm) {
//       filtered = filtered.filter((product) =>
//         product.consumeableProductName.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     const totalPages = Math.ceil(filtered.length / pagination.itemsPerPage);
//     setPagination((prev) => ({ ...prev, totalPages }));

//     const startIndex = (pagination.currentPage - 1) * pagination.itemsPerPage;
//     const endIndex = startIndex + pagination.itemsPerPage;
//     filtered = filtered.slice(startIndex, endIndex);

//     setFilteredProducts(filtered);
//   };

//   const calculatePagination = (data) => {
//     const totalPages = Math.ceil(data.length / pagination.itemsPerPage);
//     setPagination((prev) => ({ ...prev, totalPages }));
//   };

//   const handleLimitChange = (e) => {
//     const newLimit = Number(e.target.value);
//     setPagination((prev) => ({ ...prev, itemsPerPage: newLimit, currentPage: 1 }));
//   };

//   const handlePageChange = (e, page) => {
//     setPagination((prev) => ({ ...prev, currentPage: page }));
//   };

//   const handleSearchChange = (e) => setSearchTerm(e.target.value);

//   const handleApplyFilters = (filters) => {
//     setStartDate(filters.startDate);
//     setEndDate(filters.endDate);
//     setSelectedMonth(filters.month);
//     setSelectedYear(filters.year);
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleClearFilters = () => {
//     setStartDate('');
//     setEndDate('');
//     setSelectedMonth('');
//     setSelectedYear(new Date().getFullYear());
//     setSearchTerm('');
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//     setSelectedProductIds([]);
//     getData();
//   };

//   // 📂 File Upload Logic
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const data = new Uint8Array(event.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheet = workbook.Sheets[workbook.SheetNames[0]];
//         const json = XLSX.utils.sheet_to_json(sheet);

//         // Only keep 4 valid keys
//      const validData = json.map((item) => ({
//   consumeableProductName: item.consumeableProductName || '',
//   productVolume: item.productVolume || '',
//   productUnit: item.productUnit || '',
//   consumeableProductCount: item.consumeableProductCount || '', // ✅ fixed key name
// }));


//         // Validate missing fields
//         const invalid = validData.some(
//           (data) =>
//             !data.consumeableProductName ||
//             !data.productVolume ||
//             !data.productUnit ||
//             !data.consumeableProductCount
//         );

//         if (invalid) {
//           setShowMessage({
//             message: 'Some rows have missing required fields. Please check your file.',
//             messageType: 'error',
//           });
//           return;
//         }

//         setUploadedData(validData);
//       };
//       reader.readAsArrayBuffer(file);
//     }
//   };

//   // 📥 Sample Download
//   const downloadExcelTemplate = () => {
//     const a = document.createElement('a');
//     a.href = Book1ConsumeableProduct;
//     a.download = 'consumeable_product_template.xlsx';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     closeModal();
//   };

//   // 📤 Upload Submit
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     if (!uploadedData) {
//       return setShowMessage({
//         message: 'Please upload a valid Excel file.',
//         messageType: 'error',
//       });
//     }
//     try {
//       setShowLoader(true);
//       const res = await createManyConsumeableProduct(activeBranchId, { bulkData: uploadedData });
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Consumable products uploaded successfully!',
//           messageType: 'success',
//         });
//         setUploadedData(null);
//         getData();
//       } else {
//         setShowMessage({ message: res.message || 'Upload failed', messageType: 'error' });
//       }
//     } catch (err) {
//       setShowMessage({ message: err.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setShowLoader(false);
//       closeModal();
//     }
//   };

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   return (
//     <PageContainer title="Manage Products Consumption" description="this contains all consumeable products">
//       <DashboardCard2 title="Manage Products Consumption">
//         {/* Filter + Upload Section */}
//         <Box sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 3,
//           flexWrap: 'wrap',
//           gap: 2
//         }}>
//           <Box>
//             <InputLabel>Show per page</InputLabel>
//             <Select
//               sx={{
//                 borderRadius: '7px',
//                 border: '0.5px solid #6174DD',
//                 background: '#FFF',
//                 height: '40px',
//                 minWidth: '100px',
//               }}
//               value={pagination.itemsPerPage}
//               onChange={handleLimitChange}
//             >
//               <MenuItem value={10}>10</MenuItem>
//               <MenuItem value={20}>20</MenuItem>
//               <MenuItem value={50}>50</MenuItem>
//             </Select>
//           </Box>

//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//             <FilterProduct
//               selectedStartDate={startDate}
//               selectedEndDate={endDate}
//               selectedMonth={selectedMonth}
//               selectedYear={selectedYear}
//               onDateRangeSelected={setStartDate}
//               onMonthSelected={setSelectedMonth}
//               onYearSelected={setSelectedYear}
//               onClearFilters={handleClearFilters}
//               onApplyFilters={handleApplyFilters}
//               allConsumeproducts={allConsumeproducts}
//               onProductSelectionChange={setSelectedProductIds}
//             />

//             <Box sx={{ minWidth: '200px' }} onClick={() => document.getElementById('search-input').focus()}>
//               <InputLabel>Search</InputLabel>
//               <Box sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 border: '0.5px solid #6174DD',
//                 borderRadius: '7px',
//                 padding: '8px 12px',
//                 background: '#FFF'
//               }}>
//                 <img src={SearchImg} alt="" style={{ width: '20px' }} />
//                 <input
//                   id="search-input"
//                   type="text"
//                   placeholder="Search products..."
//                   value={searchTerm}
//                   onChange={handleSearchChange}
//                   style={{
//                     marginLeft: '0.5rem',
//                     border: 'none',
//                     outline: 'none',
//                     width: '100%',
//                     background: 'transparent'
//                   }}
//                 />
//                 {searchTerm && (
//                   <IconButton onClick={() => setSearchTerm('')} size="small">
//                     <ClearIcon sx={{ color: '#000', fontSize: '1.1rem' }} />
//                   </IconButton>
//                 )}
//               </Box>
//             </Box>

//             <Button
//               variant="contained"
//               sx={{ background: '#6174DD',marginTop:'1.9rem' }}
//               onClick={openModal}
//             >
//               Upload Consumeable Product
//             </Button>
//           </Box>
//         </Box>

//         {/* Upload Modal */}
//         <Dialog open={isModalOpen} onClose={closeModal}>
//           <DialogTitle>Upload Consumable Products</DialogTitle>
//           <form onSubmit={handleFormSubmit}>
//             <Box p={2}>
//               <input
//                 type="file"
//                 accept=".xlsx, .xls"
//                 onChange={handleFileChange}
//               />
//             </Box>
//             {showLoader && <ShowLoader value={showLoader} />}
//             <Box p={2}>
//               <Button type="submit" variant="contained" color="primary">
//                 Submit
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="primary"
//                 sx={{ ml: 2 }}
//                 onClick={downloadExcelTemplate}
//               >
//                 <ArrowCircleDownIcon sx={{ marginRight: '4px' }} />
//                 Sample Download
//               </Button>
//             </Box>
//           </form>
//         </Dialog>

//         <Box sx={{ mb: 2 }}>
//           <ProductGraph
//             products={allConsumeproducts}
//             startDate={startDate}
//             endDate={endDate}
//             month={selectedMonth}
//             year={selectedYear}
//           />
//         </Box>

//         {showLoader ? (
//           <ShowLoader />
//         ) : filteredProducts.length > 0 ? (
//           <Box>
//             <SingleProduct
//               data={filteredProducts}
//               activeBranchId={activeBranchId}
//               getData={getData}
//             />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//               <Pagination
//                 count={pagination.totalPages}
//                 page={pagination.currentPage}
//                 color="primary"
//                 onChange={handlePageChange}
//               />
//             </Box>
//           </Box>
//         ) : (
//           <Box sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             height: '200px',
//             color: 'text.secondary'
//           }}>
//             No consumeable products found
//           </Box>
//         )}
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default ManageConsumeProducts;

import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Select,
  MenuItem,
  IconButton,
  InputAdornment,
  InputLabel,
  Pagination,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import * as XLSX from 'xlsx';
import { useMain } from '../hooks/useMain';
import PageContainer from 'src/components/container/PageContainer';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import SearchImg from '../../assets/search.svg';
import ClearIcon from '@mui/icons-material/Clear';
import SingleProduct from './SingleProduct';
import FilterProduct from './FilterProduct';
import ProductGraph from './productGraph/ProductGraph';
import TextInputs from 'src/components/inputs/TextInputs';
import Book1ConsumeableProduct from '../../assets/excel/Book1ConsumeableProduct.xlsx'; // your sample file
import { Visibility, VisibilityOff } from '@mui/icons-material';
import BulkUploadConsumeProductDialog from './components/BulkUploadConsumeProductDialog'; 


const ManageConsumeProducts = () => {
  const [allConsumeproducts, setAllConsumeProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
 /* MASK AUTH STATE */
  const [authOpen, setAuthOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isAuthorised, setIsAuthorised] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);

  // Filter states
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
const [ownerId, setOwnerId] = useState(null);
  const [pagination, setPagination] = useState({
    itemsPerPage: 10,
    currentPage: 1,
    totalPages: 1,
  });

const {
    fetchAllConsumeProducts,
    createManyConsumeableProduct,
    activeBranchId,
    setShowMessage,
    branchData,
    OwnerVarification,
    ownerData,
     getOwnerIdByBranchId,
  } = useMain();
  const isMasked = branchData?.isMasked || false;
  // ✅ CreateManyConsumeableProduct API function (local)
  // const createManyConsumeableProduct = async (branchId, data) => {
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/consumeableproduct/bulkUpload/${branchId}`,
  //       {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: localStorage.getItem('token') || '',
  //         },
  //         body: JSON.stringify(data),
  //       }
  //     );
  //     return await response.json();
  //   } catch (err) {
  //     return { statusCode: 500, message: err.message };
  //   }
  // };

  useEffect(() => {
    if (activeBranchId && isAuthorised) {
      getData();
    }
  }, [activeBranchId, selectedProductIds, startDate, endDate, selectedMonth, selectedYear, isAuthorised]);

  useEffect(() => {
    filterProducts();
  }, [allConsumeproducts, searchTerm, pagination.itemsPerPage, pagination.currentPage]);

  const getData = async () => {
    try {
      setShowLoader(true);
      let queryParams = ``;

      if (startDate && endDate) {
        queryParams += `&startDate=${startDate}&endDate=${endDate}`;
      }

      if (selectedMonth) {
        queryParams += `&month=${selectedMonth}&year=${selectedYear}`;
      }

      const res = await fetchAllConsumeProducts(activeBranchId, queryParams ? `?${queryParams.slice(1)}` : '');

      if (res.statusCode === 200) {
        setAllConsumeProducts(res.data);
        calculatePagination(res.data);
      } else {
        setShowMessage({
          message: res.message || 'Failed to fetch data',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setShowLoader(false);
    }
  };
  // Fuzzy subsequence match — same logic used across Products/Memberships/Enquiries search.
const fuzzyMatch = (text, search) => {
  if (!search) return true;
  const lowerText = text?.toLowerCase().replace(/\s/g, '');
  if (!lowerText) return false;

  const lowerSearch = search.toLowerCase().replace(/\s/g, '');

  let textIndex = 0;
  let searchIndex = 0;
  while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
    if (lowerText[textIndex] === lowerSearch[searchIndex]) {
      searchIndex++;
    }
    textIndex++;
  }
  return searchIndex === lowerSearch.length;
};
/* CHECK STORED ACCESS */
/* CHECK STORED ACCESS */
useEffect(() => {
  if (!branchData) {
    return; // Wait until branchData is loaded
  }
  if (!isMasked) {
    setIsAuthorised(true);
    return;
  }

  const ts = localStorage.getItem('reportAccessTimestamp');
  if (ts && Date.now() - ts < 10 * 60 * 1000) {
    setIsAuthorised(true);
  }
  // dialog opens only after ownerId loads — handled below
}, [isMasked, branchData]);

useEffect(() => {
  if (!isMasked || isAuthorised) return;
  if (ownerId) {
    setAuthOpen(true); // only open once ownerId is ready
  }
}, [ownerId, isMasked, isAuthorised]);
/* FETCH OWNER ID ON MOUNT/TAB OPEN */
useEffect(() => {
  const fetchOwnerIdOnLoad = async () => {
    const branchId = activeBranchId || branchData?._id || localStorage.getItem('branchId');
    if (branchId && typeof getOwnerIdByBranchId === 'function') {
      const ownerRes = await getOwnerIdByBranchId(branchId);
      const extractedId = ownerRes?.data?.ownerId || ownerRes?.ownerId || ownerRes?.data?._id;
      const finalId = (typeof extractedId === 'object' && extractedId?._id) ? extractedId._id : extractedId;
      if (typeof finalId === 'string') {
        setOwnerId(finalId);
      }
    }
  };
  fetchOwnerIdOnLoad();
}, [activeBranchId, branchData?._id, getOwnerIdByBranchId]);

  const handleCloseDialogue = () => {
    setAuthOpen(false);
    setPassword('');
    setShowPassword(false);
  };

  /* PASSWORD SUBMIT  */
  const handleAuthSubmit = async () => {
  if (!password) {
    setShowMessage({ message: 'Enter login password', messageType: 'error' });
    return;
  }

  if (!ownerId) {
    setShowMessage({ message: 'Owner ID not found. Please refresh and try again.', messageType: 'error' });
    return;
  }

  try {
    setAuthLoading(true);
    const res = await OwnerVarification(ownerId, { password }); // <-- changed from ownerData?._id

    if (res?.statusCode === 200) {
      localStorage.setItem('reportAccessTimestamp', Date.now());
      setIsAuthorised(true);
      setAuthOpen(false);
      setPassword('');
      setShowPassword(false);
    } else {
      setShowMessage({ message: res?.message || 'Invalid password', messageType: 'error' });
    }
  } catch (err) {
    console.error('Auth error:', err);
    setShowMessage({ message: 'Something went wrong', messageType: 'error' });
  } finally {
    setAuthLoading(false);
  }
};
  const filterProducts = () => {
    let filtered = [...allConsumeproducts];
    if (selectedProductIds.length > 0) {
      filtered = filtered.filter((product) => selectedProductIds.includes(product._id));
    }
     const cleanSearch = searchTerm.trim();
    if (cleanSearch) {
      filtered = filtered.filter((product) =>
        fuzzyMatch(product.consumeableProductName, cleanSearch)
      );
    }

    const totalPages = Math.ceil(filtered.length / pagination.itemsPerPage);
    setPagination((prev) => ({ ...prev, totalPages }));

    const startIndex = (pagination.currentPage - 1) * pagination.itemsPerPage;
    const endIndex = startIndex + pagination.itemsPerPage;
    filtered = filtered.slice(startIndex, endIndex);

    setFilteredProducts(filtered);
  };

  const calculatePagination = (data) => {
    const totalPages = Math.ceil(data.length / pagination.itemsPerPage);
    setPagination((prev) => ({ ...prev, totalPages }));
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setPagination((prev) => ({ ...prev, itemsPerPage: newLimit, currentPage: 1 }));
  };

  const handlePageChange = (e, page) => {
    setPagination((prev) => ({ ...prev, currentPage: page }));
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.trimStart());
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  // Trims the pasted text, then inserts it at the cursor position
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setSearchTerm(next);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      setSearchTerm(trimmed);
    }
  };

  const handleApplyFilters = (filters) => {
    setStartDate(filters.startDate);
    setEndDate(filters.endDate);
    setSelectedMonth(filters.month);
    setSelectedYear(filters.year);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleClearFilters = () => {
    setStartDate('');
    setEndDate('');
    setSelectedMonth('');
    setSelectedYear(new Date().getFullYear());
    setSearchTerm('');
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    setSelectedProductIds([]);
    getData();
  };

  // 📂 File Upload Logic
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(sheet);

        // Only keep 4 valid keys
     const validData = json.map((item) => ({
  consumeableProductName: item.consumeableProductName || '',
  productVolume: item.productVolume || '',
  productUnit: item.productUnit || '',
  consumeableProductCount: item.consumeableProductCount ?? '', // ✅ fixed key name
     }));
         console.log(validData, 'dateeee');


        // Validate missing fields
        const invalid = validData.some(
          (data) =>
            !data.consumeableProductName ||
            !data.productVolume ||
            !data.productUnit ||
            data.consumeableProductCount === '' ||
            data.consumeableProductCount === null ||
            data.consumeableProductCount === undefined,
        );
        console.log(invalid, 'invalfid');

        if (invalid) {
          setShowMessage({
            message: 'Some rows have missing required fields. Please check your file.',
            messageType: 'error',
          });
          return;
        }

        setUploadedData(validData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  // 📥 Sample Download
  const downloadExcelTemplate = () => {
    const a = document.createElement('a');
    a.href = Book1ConsumeableProduct;
    a.download = 'consumeable_product_template.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    closeModal();
  };

  // 📤 Upload Submit
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!uploadedData) {
      return setShowMessage({
        message: 'Please upload a valid Excel file.',
        messageType: 'error',
      });
    }
    try {
      setShowLoader(true);
      const res = await createManyConsumeableProduct(activeBranchId, { bulkData: uploadedData });
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Consumable products uploaded successfully!',
          messageType: 'success',
        });
        setUploadedData(null);
        getData();
      } else {
        setShowMessage({ message: res.message || 'Upload failed', messageType: 'error' });
      }
    } catch (err) {
      setShowMessage({ message: err.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setShowLoader(false);
      closeModal();
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  if (isMasked && !isAuthorised) {
    return (
       <PageContainer title="Manage Products Consumption" description="this contains all consumeable products">
        <DashboardCard2 title="Manage Products Consumption">
          <Dialog open={authOpen} onClose={handleCloseDialogue}>
            <DialogTitle>Confirm Request</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please enter the owner password to access this page.
              </DialogContentText>
              <Box style={{ marginTop: '10px' }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextInputs
                      title="Login Password"
                      name="password"
                      value={password}
                      handleChange={(e) => setPassword(e.target.value)}
                      type={showPassword ? 'text' : 'password'}
                      disabled={authLoading}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                              disabled={authLoading}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleCloseDialogue}>Cancel</Button>
              <Button onClick={handleAuthSubmit} disabled={authLoading}>
                {authLoading ? 'Verifying...' : 'Submit'}
              </Button>
            </DialogActions>
          </Dialog>
        </DashboardCard2>
      </PageContainer>
    );
  }

  return (
     <PageContainer title="Manage Products Consumption" description="this contains all consumeable products">
  <DashboardCard2 title="Manage Products Consumption">
    {/* Filter + Upload Section */}
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      mb: 3,
    }}>
      {/* Left side - Show per page */}
      <Box>
        <InputLabel>Show per page</InputLabel>
        <Select
          sx={{
            borderRadius: '7px',
            border: '0.5px solid #6174DD',
            background: '#FFF',
            height: '40px',
            minWidth: '100px',
          }}
          value={pagination.itemsPerPage}
          onChange={handleLimitChange}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>           <MenuItem value={1000000}>All</MenuItem>
        </Select>
      </Box>

      {/* Right side - Search, Filter and Upload button */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'flex-end', 
        gap: '0.8rem'
      }}>
        {/* Search */}
        <Box onClick={() => document.getElementById('search-input').focus()}>
          <InputLabel>Search</InputLabel>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            border: '0.5px solid #6174DD',
            borderRadius: '7px',
            padding: '4px 12px',
            background: '#FFF',
            height: '40px',
            Width: '150px'
          }}>
            <img src={SearchImg} alt="" style={{ width: '20px', marginRight: '8px' }} />
            <input
              id="search-input"
              type="text"
              placeholder="Search Products..."
              value={searchTerm}
              onChange={handleSearchChange}
              onPaste={handleSearchPaste}
              onBlur={handleSearchBlur}
              style={{
                border: 'none',
                outline: 'none',
                width: '150px',
                background: 'transparent'
              }}
            />
            {searchTerm && (
              <IconButton onClick={() => setSearchTerm('')} size="small" sx={{ padding: 1 }}>
                <ClearIcon sx={{ color: '#000', fontSize: '1.1rem' }} />
              </IconButton>
            )}
          </Box>
        </Box>

        {/* Filter */}
        <Box style={{width:'150px'}}>
          <FilterProduct
            selectedStartDate={startDate}
            selectedEndDate={endDate}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            onDateRangeSelected={setStartDate}
            onMonthSelected={setSelectedMonth}
            onYearSelected={setSelectedYear}
            onClearFilters={handleClearFilters}
            onApplyFilters={handleApplyFilters}
            allConsumeproducts={allConsumeproducts}
            onProductSelectionChange={setSelectedProductIds}
          />
        </Box>

        {/* Upload Button */}
        {/* <Box>
          <Button
            variant="contained"
            sx={{ 
              background: '#6174DD', 
              height: '40px',
              minWidth: '200px'
            }}
            onClick={openModal}
          >
            Upload Consumeable Product
          </Button>
        </Box> */}
        <Box>
  <BulkUploadConsumeProductDialog
    onUploaded={getData}
    existingProducts={allConsumeproducts}
      />
    </Box>
      </Box>
    </Box>

    {/* Upload Modal */}
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Upload Consumable Products</DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <Box p={2}>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
        </Box>
        {showLoader && <ShowLoader value={showLoader} />}
        <Box p={2}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
          <Button
            variant="outlined"
            color="primary"
            sx={{ ml: 2 }}
            onClick={downloadExcelTemplate}
          >
            <ArrowCircleDownIcon sx={{ marginRight: '4px' }} />
            Sample Download
          </Button>
        </Box>
      </form>
    </Dialog>

    <Box sx={{ mb: 2 }}>
      <ProductGraph
        products={allConsumeproducts}
        startDate={startDate}
        endDate={endDate}
        month={selectedMonth}
        year={selectedYear}
      />
    </Box>

    {showLoader ? (
      <ShowLoader />
    ) : filteredProducts.length > 0 ? (
      <Box>
        <SingleProduct
          data={filteredProducts}
          activeBranchId={activeBranchId}
          getData={getData}
          isAuthorised={isAuthorised}
          isMasked={isMasked}
          search={searchTerm.trim()}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            color="primary"
            onChange={handlePageChange}
          />
        </Box>
      </Box>
    ) : (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        color: 'text.secondary'
      }}>
        No consumeable products found
      </Box>
    )}
  </DashboardCard2>
</PageContainer>
  );
};

export default ManageConsumeProducts;

